let canvas, ctx;

const triggerDownload = (imgURI) => {
  const a = document.createElement("a");
  a.download = "Nature_Hero_Postcard.png"; // filename
  a.target = "_blank";
  a.href = imgURI;
  a.dispatchEvent(
    new MouseEvent("click", {
      view: window,
      bubbles: false,
      cancelable: true,
    })
  );
};

const fragmentText = (text, maxWidth) => {
  var words = text.split(" "),
    lines = [],
    line = "";
  if (ctx.measureText(text).width < maxWidth) {
    return [text];
  }
  while (words.length > 0) {
    var split = false;
    while (ctx.measureText(words[0]).width >= maxWidth) {
      var tmp = words[0];
      words[0] = tmp.slice(0, -1);
      if (!split) {
        split = true;
        words.splice(1, 0, tmp.slice(-1));
      } else {
        words[1] = tmp.slice(-1) + words[1];
      }
    }
    if (ctx.measureText(line + words[0]).width < maxWidth) {
      line += words.shift() + " ";
    } else {
      lines.push(line);
      line = "";
    }
    if (words.length === 0) {
      lines.push(line);
    }
  }
  return lines;
};


export default (id = 0) => ({
  formId: id,
  submitted: false,
  flipped: false,
  heroName: "",
  heroDescription: "",
  name: "",
  init() {
    canvas = document.getElementById("postcard-canvas");
    ctx = canvas.getContext("2d");

    let heroNameInput = this.$el.querySelector(".input-hero-name input");
    this.heroName = heroNameInput.value;
    Alpine.bind(heroNameInput, { "x-model": "heroName" });

    let heroDescriptionInput = this.$el.querySelector(
      ".input-hero-description textarea"
    );
    this.heroDescription = heroDescriptionInput.value;
    Alpine.bind(heroDescriptionInput, { "x-model": "heroDescription" });

    let nameInput = this.$el.querySelector(".input-name input");
    this.name = nameInput.value;
    Alpine.bind(nameInput, { "x-model": "name" });


  },
  onSubmit(e) {
    if (e.detail == this.formId) {
      this.submitted = true;
    }
  },
  async draw() {
    return new Promise((resolve) => {
      const image = new Image();
      image.src = "/app/themes/rewild-yourself/static/images/postcard-full.png";
      image.onload = () => {
        ctx.drawImage(image, 0, 0, 1480, 2100);
        ctx.font = "46px Tenez";
        ctx.textAlign = "center";
        ctx.letterSpacing = "0.01em";
        ctx.fillText(this.heroName, 370, 1474);

        ctx.font = "italic 40px Tenez";
        ctx.textAlign = "left";
        ctx.fillText("To:  " + this.heroName, 824, 1590);
        ctx.fillText("From:  " + this.name, 824, 1758);

        ctx.font = "24px MrEavesXLModOT";
        ctx.letterSpacing = "0.03em";
        let lines = fragmentText(this.heroDescription, 600);
        let y = 1570;
        lines.map((text) => {
          ctx.fillText(text, 80, y);
          y = y + 42;
        });

        resolve();
      };
    });
  },
  async download() {
    await this.draw();
    const imgURI = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    triggerDownload(imgURI);
  },
});

